import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Format a duration in seconds to "Xh Ym Zs" or "Mm:SSs" style display */
export function formatDuration(totalSeconds: number): string {
  const h = Math.floor(totalSeconds / 3600);
  const m = Math.floor((totalSeconds % 3600) / 60);
  const s = totalSeconds % 60;
  if (h > 0) return `${h}h${m.toString().padStart(2, "0")}`;
  return `${m}:${s.toString().padStart(2, "0")}`;
}

/** Get duration in seconds from episode data, preferring duration_seconds over duration_minutes */
export function getEpisodeDurationSeconds(episode: { duration_seconds?: number | null; duration_minutes?: number | null }): number | null {
  if (episode.duration_seconds != null) return episode.duration_seconds;
  if (episode.duration_minutes != null) return episode.duration_minutes * 60;
  return null;
}
